module.exports = __webpack_public_path__ + "img/microsoft.4f4e02cd.png";